import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';

interface StripePaymentFormProps {
    children: React.ReactNode;
    stripe: any;
}

const StripePaymentForm: React.FC<StripePaymentFormProps> = ({
    children,
    stripe,
}) => {
    const [options, setOptions] = useState({ clientSecret: '' });

    useEffect(() => {
        async function setSetupIntent() {
            const res = await fetch('/api/setup-intent');

            if (res) {
                const respCli = await res.json();

                setOptions({ clientSecret: respCli.clientSecret });
            }
        }
        setSetupIntent();
    }, []);

    if (!options?.clientSecret) return null;

    return (
        <Elements options={options} stripe={stripe}>
            {children}
        </Elements>
    );
};

export default StripePaymentForm;
